var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-material-alert',{attrs:{"color":"warning","dark":"","dismissible":"","icon":"mdi-bell"}},[_vm._v(" "+_vm._s(_vm.$t('monitoring.empty-note'))+" "),_c('router-link',{attrs:{"to":("/" + _vm.link)},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
return [_c('a',{attrs:{"href":href},on:{"click":navigate}},[_vm._v(_vm._s(_vm.text)+" "+_vm._s(_vm.$t('monitoring.add-some')))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }